
/* Usage
 *    Function calls .post/sf-check-rebates-lop endpoint after user signed in, or after primary address added.
 *    Gets ca_sfid from SalesForce and sets rebate_lop_id="**ca_sfid**" tag at Shopify customer account.
 *
 *  @param {String} customerId - Shopify ID of the customer. 
 *  @return {String}: success : failure
 */

function checkRebatesLOP(customerId) {
    return $.post(checkRebatesLOPUrl, {
        customerId: customerId.replaceAll('"', ''),
    }, 'json').done(function (res) {
        if (res) {
            console.log("checkRebatesLOP()=Success");
            return res;
        }
    }).fail(function (error) {
        //alert(error.message);
        console.log('Error checkRebatesLOP(): ', error);
        return;
    });
}


/* Usage
 *    This function will create a new <a> tag, generate click() event, and open new browser tab.
 *    It is intended to bapass browser popup blockers and to functions as window.open(url, '_blank');
 *
 *  @param {String} url - The URL of the page to open.
 *  @param {String} target - Name of the browsing context the resource is being loaded into. Keywords: _blank, _parent, _self.
 */
 function openNewBrowserWindow(url, target) {
    let a = document.createElement('a');
    a.href = url;
    a.target = target;
    a.click();
}
